export default "__VITE_ASSET__lx96dfj5__"